(function () {
  'use strict';

  // Highlight active bottom bar item
  var path = window.location.pathname;
  var items = document.querySelectorAll('.mobile-bottom-bar__item');
  items.forEach(function (item) {
    var href = item.getAttribute('href');
    if (href && path === href) item.classList.add('is-active');
  });

  // Recently viewed tracker (stores product handles + titles + images)
  var RV_KEY = 'catchy_recently_viewed';

  function getRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; }
    catch (e) { return []; }
  }

  function addRecentlyViewed(data) {
    if (!data || !data.handle) return;
    var list = getRecentlyViewed().filter(function (p) { return p.handle !== data.handle; });
    list.unshift(data);
    if (list.length > 12) list = list.slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }

  // On product pages, track the view
  if (document.body.classList.contains('template-product')) {
    var productData = window.CATCHY && window.CATCHY.product;
    if (!productData) {
      // Try to read from page elements (using actual theme class names)
      var titleEl = document.querySelector('.pm-title') || document.querySelector('.product-info__title');
      var priceEl = document.querySelector('.pm-price-new') || document.querySelector('.product-info__price');
      var imgEl = document.querySelector('.pm-slide__img') || document.querySelector('.product-gallery__main-img');
      if (titleEl) {
        addRecentlyViewed({
          handle: window.location.pathname.split('/products/').pop().split('?')[0],
          title: titleEl.textContent.trim(),
          price: priceEl ? priceEl.textContent.trim() : '',
          image: imgEl ? imgEl.src : '',
          url: window.location.pathname
        });
      }
    } else {
      addRecentlyViewed({
        handle: productData.handle,
        title: productData.title,
        price: productData.price ? 'EGP ' + (productData.price / 100).toFixed(0) : '',
        image: productData.featured_image || '',
        url: '/products/' + productData.handle
      });
    }
  }

  // Render recently viewed section
  var rvSection = document.getElementById('recently-viewed-section');
  var rvGrid = document.getElementById('recently-viewed-grid');
  if (rvSection && rvGrid) {
    var currentHandle = window.location.pathname.split('/').pop();
    var products = getRecentlyViewed().filter(function (p) { return p.handle !== currentHandle; }).slice(0, 4);
    if (products.length > 0) {
      rvSection.style.display = 'block';
      rvGrid.innerHTML = products.map(function (p) {
        return '<div class="product-card">' +
          '<a href="' + p.url + '" class="product-card__link">' +
          '<div class="product-card__media">' +
          (p.image ? '<img src="' + p.image + '" alt="' + escHtml(p.title) + '" class="product-card__img" loading="lazy">' : '<div class="product-card__img" style="background:var(--c-light-gray);height:100%;"></div>') +
          '</div></a>' +
          '<div class="product-card__info">' +
          '<a href="' + p.url + '" class="product-card__title">' + escHtml(p.title) + '</a>' +
          '<div class="product-card__price">' + formatRvPrice(p.price) + '</div>' +
          '</div></div>';
      }).join('');
      if (window.CATCHY && window.CATCHY.reobserve) window.CATCHY.reobserve();
    }
  }

  function formatRvPrice(price) {
    if (!price) return '';
    // If already formatted string (contains letters), show as-is
    if (isNaN(price)) return price;
    // If raw cents number, convert
    return 'EGP ' + Math.round(parseInt(price) / 100);
  }

  function escHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  window.CATCHY = window.CATCHY || {};
  window.CATCHY.recentlyViewed = { add: addRecentlyViewed, get: getRecentlyViewed };
})();
